// @ts-expect-error -- there are no types for this library
import JsonApi from 'devour-client';

import type { JsonApiTypeHelper } from './JsonApiTypeHelper.types';
import type { Subscription } from 'Backend/billing/types';

import Config from 'Config';
import { requestMiddleware, subscriptionsMiddleware } from './Middleware';

const SubscriptionsApi = new JsonApi({ apiUrl: Config.subscriptions_api });

SubscriptionsApi.insertMiddlewareBefore('axios-request', requestMiddleware);
SubscriptionsApi.insertMiddlewareBefore('axios-request', subscriptionsMiddleware);

SubscriptionsApi.define('subscription', {
    type: '',
    id: '',
    planId: '',
    companyId: '',
    managingTenantId: '',
    status: '',
    featureOptIns: {
        xero: '',
        myob: '',
        netsuite: '',
        brandedBusinessAccounts: '',
        bulkPayments: '',
        apiAccess: '',
        payroll: '',
        lineItemExtraction: '',
        beneficiaryValidation: '',
        approvalWorkflows: '',
        partialPayments: '',
    },
    activeDate: '',
    cancelledDate: '',
    customerCancelDate: '',
    cutoffDate: '',
    suspendedDate: '',
    forceActive: '',
    cardId: '',
    chargeWallet: '',
    cancelReason: '',
    trial: {
        startDate: '',
        endDate: '',
    },
    billingContact: {
        jsonApi: 'hasOne',
        type: 'billingContact',
    },
    customFees: {
        jsonApi: 'hasOne',
        type: 'customFees',
    },
    createdAt: '',
    updatedAt: '',
    pricingCurrency: '',
});

SubscriptionsApi.define('managed', {
    type: '',
    id: '',
    planId: '',
    companyId: '',
    managingTenantId: '',
    status: '',
    featureOptIns: {
        xero: '',
        myob: '',
        netsuite: '',
        brandedBusinessAccounts: '',
        bulkPayments: '',
        apiAccess: '',
        payroll: '',
        lineItemExtraction: '',
        beneficiaryValidation: '',
        approvalWorkflows: '',
        partialPayments: '',
    },
    activeDate: '',
    cancelledDate: '',
    customerCancelDate: '',
    cutoffDate: '',
    suspendedDate: '',
    forceActive: '',
    cardId: '',
    chargeWallet: '',
    cancelReason: '',
    trial: {
        startDate: '',
        endDate: '',
    },
    billingContact: {
        jsonApi: 'hasOne',
        type: 'billingContact',
    },
    customFees: {
        jsonApi: 'hasOne',
        type: 'customFees',
    },
    createdAt: '',
    updatedAt: '',
    pricingCurrency: '',
});

SubscriptionsApi.define('billingContact', {
    mobile: '',
    name: '',
    email: '',
});

SubscriptionsApi.define('customFees', {
    domesticDirect: 0,
    swift: 0,
    swiftDeposit: 0,
    fxMarginPercent: 0,
});

const SubscriptionsApiExport = SubscriptionsApi as JsonApiTypeHelper<Subscription, 'subscription' | 'managed'>;

export { SubscriptionsApiExport as SubscriptionsApi };
